export function toggleMenu() {
  const hamburger = document.querySelector('#hamburger');
  const mainMenu = document.querySelector('#main-menu');
  const closeButton = document.querySelector('#mobile-menu-close');
  const desktopSearch = document.querySelector('#desktop-search');

  if (desktopSearch) {
    const searchToggle = desktopSearch.querySelector('.header-search-toggle');

    searchToggle?.addEventListener('click', (event) => {
      event.stopPropagation();
      desktopSearch.classList.add('is-open');

      const input = desktopSearch.querySelector('input[type="search"]');
      if (input instanceof HTMLInputElement) {
        input.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!desktopSearch.contains(event.target)) {
        desktopSearch.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        desktopSearch.classList.remove('is-open');
      }
    });
  }

  if (hamburger === null || mainMenu === null) {
    return;
  }

  const closeMenu = () => {
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    mainMenu.classList.remove('active');

    window.setTimeout(() => {
      if (!mainMenu.classList.contains('active')) {
        mainMenu.setAttribute('hidden', 'hidden');
      }
    }, 300);

    document.body.classList.remove('open');
  };

  const openMenu = () => {
    mainMenu.removeAttribute('hidden');
    window.requestAnimationFrame(() => {
      mainMenu.classList.add('active');
    });

    hamburger.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('open');
  };

  hamburger.addEventListener('click', () => {
    if (mainMenu.classList.contains('active')) {
      closeMenu();
      return;
    }

    openMenu();
  });

  closeButton?.addEventListener('click', closeMenu);

  mainMenu.addEventListener('click', (event) => {
    if (event.target === mainMenu) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mainMenu.classList.contains('active')) {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      closeMenu();
    }
  });
}
